import React from "react";
import { connect } from "react-redux";
import ParamTables from "./param-tables";
import MedicalConclusion from "./medical-conclusion";

import { openModalDialog, openModalDialogWithMode } from "../../redux/actions/report-actions";
import { graphIntervals_dialog, medicalReport_dialog } from "../popup-dialog-manager/constants";

import OrgHeader from "./page1-org-header";
import PageFooter from "./page1-footer";
import withLocalization from "../../hoc/with-localization";
import GraphRepresentativeCmpx from "./graph-representative-cmpx";

import "./report-page1.scss";

import CircleGraphComponent from "./circle-graph-component";
import { modal_mode_halfscreen } from "../../redux/actions/actionConstants";

class ReportPage1 extends React.Component {
    render() {
        const {
            reportData,
            fd,
            openModalDialog,
            openModalDialogWithMode,
            editMode,
            needCmpxVerification,
            needDialogTableParams,
            cmpxVerificated,
            halfPopup
        } = this.props;
        if (!reportData) {
            return null;
        }
        const popupable = editMode && !halfPopup;
        const { representativeCmpx, doctorName, resultDate, signInfo } = reportData.report;

        const ECGCaption = withLocalization(({ loc }) => <h3>{loc("report.captions.ECG")}</h3>);

        // Показывать интервалы, если: НЕТ режима верификации интервалов;
        // ЕСТЬ режима верификации интервалов: * комплекс верифицирован, * При открытии разметок, сделанных БЕЗ режима верификации, И заключение подписано
        // const needIntervals = needCmpxVerification
        //     ? cmpxVerificated === true || ((cmpxVerificated === undefined || cmpxVerificated === null) && signInfo.signed)
        //     : true;

        const needIntervals = needCmpxVerification ? cmpxVerificated : true;
        return (
            <div className="page page1">
                <OrgHeader />
                <div className="page1__left">
                    <div className="medical-report">
                        <ECGCaption />
                        <ParamTables
                            {...{
                                ...reportData,
                                fd,
                                openDialog: openModalDialog,
                                popupable,
                                needIntervals,
                                needDialogTableParams
                            }}
                        />
                        <CircleGraphComponent angles={representativeCmpx?.angles} needIntervals={needIntervals} />
                        <MedicalConclusion
                            openDialog={() => openModalDialogWithMode({ dialog: medicalReport_dialog, mode: modal_mode_halfscreen })}
                            popupable={popupable}
                        />
                    </div>
                </div>
                <div className="page1__right">
                    <GraphRepresentativeCmpx openDialog={() => openModalDialog(graphIntervals_dialog)} popupable={popupable} />
                </div>
                <PageFooter {...{ signInfo, doctorName, resultDate }} />
            </div>
        );
    }
}
const mapStateToProps = ({ reportApp: { reportData, app } }) => {
    const { signal: { fd } = {} } = reportData.report;

    const { NeedCmpxIntervalsVerification: needCmpxVerification, NeedDialogTableParams: needDialogTableParams } = reportData.settings;
    const { verificated } = reportData?.report?.representativeCmpx || {};
    return {
        reportData,
        fd,
        needCmpxVerification,
        needDialogTableParams,
        cmpxVerificated: verificated,
        editMode: app.settings.editMode,
        halfPopup: app.modal.opened && app.modal.dialogMode === modal_mode_halfscreen
    };
};

const mapDispatchToProps = {
    openModalDialog,
    openModalDialogWithMode
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportPage1);

//style={{background:"red"}}
